import * as React from 'react';
import { createSvg } from '../../utils/createSvg';
export var ArrowLeft = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M27.999 16a1 1 0 0 1-1 1H8.413l7.293 7.293a.999.999 0 1 1-1.414 1.414l-9-9a.999.999 0 0 1-.216-1.089.999.999 0 0 1 .216-.325l9-9a.999.999 0 1 1 1.414 1.414L8.413 15h18.586a1 1 0 0 1 1 1" })), '0 0 32 32', 'ArrowLeft');
//# sourceMappingURL=ArrowLeft.js.map